import VerofreshHttpAdapter from '@/orm/VeroFreshHttpAdapter'
import UrlHelper from '@/util/Url'

/**
 * Generic global application state that doesn't really belong anywhere else.
 */
export default {
  state: {
    unassessedRouteCount: undefined,
    unregisteredLocationCount: undefined
  },
  getters: {
    unassessedRouteCount: state => {
      return state.unassessedRouteCount
    },
    unregisteredLocationCount: state => {
      return state.unregisteredLocationCount
    }
  },
  mutations: {
    setUnassessedRouteCount (state, count) {
      state.unassessedRouteCount = count
    },
    setUnregisteredLocationCount (state, count) {
      state.unregisteredLocationCount = count
    }
  },
  actions: {
    refreshUnassessedRouteCount (context, customerId) {
      VerofreshHttpAdapter({
        method: 'GET',
        url: `${UrlHelper.getApiUrl()}/route/unassessed-count/`,
        params: {
          customer_id: customerId
        }
      }).then(resp => {
        context.commit('setUnassessedRouteCount', resp.data)
      }).catch(error => {
        throw (error)
      })
    },
    setUnassessedRouteCount (context, count) {
      context.commit('setUnassessedRouteCount', count)
    },
    refreshUnregisteredLocationCount (context, customerId) {
      VerofreshHttpAdapter({
        method: 'GET',
        url: `${UrlHelper.getApiUrl()}/location/unregistered-count/`,
        params: {
          customer_id: customerId
        }
      }).then(resp => {
        context.commit('setUnregisteredLocationCount', resp.data)
      }).catch(error => {
        throw (error)
      })
    }
  }
}
